import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  transform(object): any {
    if (!_.isObject(object)) {
      return object;
    }
    return Object.keys(object).map(key => ({
      key,
      value: object[key],
    }));
  }
}
